import React, { Component } from 'react';
import CourseMiddleware from '../../store/middleware/courseMiddleware';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import CourseActions from '../../store/actions/courseActions';
import QuizMiddleware from '../../store/middleware/quizMiddleware';
import { connect } from 'react-redux';
import { Typography } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';

class QuizInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            completedAnswerSheet: [],
            inProgressAnswerSheet : [],
            buttonLoader : false,
            networkErrorInDeleteAnswerSheet : false,
            // quizLoader : props.state.quizLoader
        }
    }
    
    componentWillUnmount() {
        this.props.clearmodule()
    }

    // componentDidMount(){
    //     this.props.getquiz({ quizId: this.props.data.quiz , userId: this.props.userDetails._id, courseId: this.props.modulesData.course, pc_access_token: this.props.userDetails.pc_access_token })
    //     this.setState({
    //         quizLoader: true
    //     })
    // }

    componentWillReceiveProps(nextProps) {
        if ( nextProps.quizDetails && nextProps.quizDetails.quiz && nextProps.quizDetails.answerSheet) {
            // this.setState({ quizLoader : false})
            let complete = [];
            complete = nextProps.quizDetails.answerSheet.filter((data) => data.status == 'completed')
            this.setState({ completedAnswerSheet: complete })

            let inProgress = [];
            inProgress = nextProps.quizDetails.answerSheet.filter((data) => data.status == 'inProgress')
            this.setState({ inProgressAnswerSheet: inProgress })
        }

        if (nextProps.deleteAnswerSheet && nextProps.deleteAnswerSheet._id) {
            this.setState({buttonLoader : false, inProgressAnswerSheet : [], networkErrorInDeleteAnswerSheet : false})
        }

        if ( nextProps.errorInDeleteAnswerSheet ) {
            this.setState({
                networkErrorInDeleteAnswerSheet : true,
                buttonLoader : false
            })
        }
    }

    render() {
        let months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
        return (
            <ExpansionPanel expanded={this.props.state.quizDetailsPanel === this.props.index} onChange={this.props.quizData(this.props.index,this.props.data)}>
            <ExpansionPanelSummary 
                expandIcon={<ExpandMoreIcon />} 
                style={{ 
                    backgroundColor: this.props.state.quizDetailsPanel === this.props.index ? 'lightgrey' : 'white'
                }}
                className = "quiz-list-panel"
            >
                Quiz Title : {this.props.data.title}
            </ExpansionPanelSummary>
                {this.props.state.quizLoader ?
                    <div style={{ justifyContent: "center", alignItems: "center", display: "flex", marginBottom: "1%" }}><CircularProgress size={50} thickness={3} style={{color : "#13a89e"}} /></div> :
                    <div>
                        {this.props.quizDetails.quiz && this.props.quizDetails.quiz._id && <div>
                            <ExpansionPanelDetails style={{ marginLeft: "2%" }}> <div style={{ width: "98%", marginTop : "1%" }}> <b> Description : </b> {this.props.quizDetails && this.props.quizDetails.quiz && this.props.quizDetails.quiz.desc}</div> </ExpansionPanelDetails>
                            {/*
                                this.props.classDetails.showResultToStudents && 
                                <ExpansionPanelDetails style={{ marginLeft: "2%" }}> <div> <b> Passing Score : </b>{this.props.quizDetails && this.props.quizDetails.quiz && this.props.quizDetails.quiz.passingScore}</div></ExpansionPanelDetails>
                            */}
                            <ExpansionPanelDetails style={{ marginLeft: "2%" }}> <div> <b> Quiz Duration : </b> {this.props.quizDetails && this.props.quizDetails.quiz && this.props.quizDetails.quiz.duration} Minutes </div></ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ marginLeft: "2%" }}> <div> <b> No. of Attempts Allowed : </b> {this.props.quizDetails && this.props.quizDetails.quiz && this.props.quizDetails.quiz.noOfAttempts} </div></ExpansionPanelDetails>
                        </div>}
                        {this.state.inProgressAnswerSheet && this.state.inProgressAnswerSheet.length ?
                        <div style={{marginBottom : "4%"}}> 
                            {this.state.inProgressAnswerSheet.map(data => {
                                return <div style={{display:"flex", justifyContent : "space-evenly"}}>
                                            <div style={{ flexDirection: "column", display: "flex", border: "1px solid #D3D3D3", width: "30%", textAlign : "center" }}><Typography style={{ fontWeight: "bold", fontSize: "20px", width: "100%", backgroundColor: "#13a89e", color: "white" }}>Questions Already Attempted</Typography> <Divider /> <Typography style={{ fontWeight: "bold", fontSize: "23px", paddingTop: "2%" }}>{data.answers}</Typography></div>
                                            <div style={{ flexDirection: "column", display: "flex", border: "1px solid #D3D3D3", width: "30%", textAlign : "center"  }}><Typography style={{ fontWeight: "bold", fontSize: "20px", width: "100%", backgroundColor: "#13a89e", color: "white" }}>Timespent</Typography> <Divider /> <Typography style={{ fontWeight: "bold", fontSize: "23px", paddingTop: "2%" }}>{data.timeConsumed ? Math.floor(data.timeConsumed / (60 * 60))+ " : " + Math.floor((data.timeConsumed % (60*60)) / 60) + " : " + Math.ceil((data.timeConsumed % (60*60))%60): "N/A"}</Typography></div>
                                        </div>
                            })}</div> : ""
                        }
                        
                        <ExpansionPanelDetails style={{ marginLeft: "2%" }}> {this.state.completedAnswerSheet.length ?

                            <div style={{ width: "98%" }}>
                                {this.state.completedAnswerSheet.map((data, index) => {
                                    return (<Paper style={{ marginBottom: "5%" }} key={index}>
                                        <Table>
                                            <TableHead style={{ backgroundColor: "#13a89e" }}>
                                                <TableRow>
                                                    <TableCell style={{ color: "white", fontSize: "250%", textAlign: "center", fontWeight: "bold" }}> Attempt : {index + 1} {months[new Date(data.created).getMonth()]} {new Date(data.created).getDate()}, {new Date(data.created).getFullYear()}</TableCell>
                                                    <TableCell style={{ color: "white", fontSize: "250%", textAlign: "center", fontWeight: "bold" }}> Time Taken</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.props.classDetails.showResultToStudents ?
                                                    <TableRow>
                                                        <TableCell style={{ fontSize: "250%", textAlign: "center", fontWeight: "bold" }}>Your Score : {data.score}%</TableCell>
                                                        <TableCell style={{ fontSize: "250%", textAlign: "center", fontWeight: "bold" }}>{data.timeConsumed ? Math.floor(data.timeConsumed / (60 * 60))+ " : " + Math.floor((data.timeConsumed % (60*60)) / 60) + " : " + Math.ceil((data.timeConsumed % (60*60))%60): "N/A"}</TableCell>
                                                    </TableRow>
                                                    :
                                                    <TableRow>
                                                        <TableCell colSpan="2" style={{ fontSize: "100%", textAlign: "center", fontWeight: "bold" }}>
                                                            <Typography style={{ fontWeight: "bold", fontSize: "100%", paddingBottom: "20px" }}>
                                                                Results will be published over the official PIAIC communication channels and the PIAIC Student Portal.
                                                            </Typography>
                                                            <br></br>
                                                            <Typography style={{ fontWeight: "bold", fontSize: "100%", paddingBottom: "20px" }}>
                                                                Please note: As defined in the course syllabus, the PIAIC grading policy is based on a percentile ranking system. Therefore, all results will be released once testing for all students is completed.
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                            </TableBody>
                                        </Table>
                                    </Paper>)
                                })}

                            {this.state.buttonLoader ?
                                <CircularProgress size={40} thickness={3} style={{color : "#13a89e"}} /> : 
                                <div>
                                    {((this.props.quizDetails.quiz && this.props.quizDetails.quiz.noOfAttempts) > (this.state.completedAnswerSheet.length) && (!this.state.inProgressAnswerSheet.length) )?                    
                                            <Link style={{ textDecoration: "none", color: "white" }} to={{ pathname: "/quiz/proctor", state: { quizDetails: this.props.quizDetails, classDetails: this.props.classDetails, userDetails: this.props.userDetails } }} ><Button variant="contained" color="primary" style={{backgroundColor : "#13a89e"}}>Retake Quiz</Button></Link>
                                         : <div style={{display : "flex"}}>{this.state.inProgressAnswerSheet.length ? 
                                            <Link style={{ textDecoration: "none", color: "white" }} to={{ pathname: "/quiz/proctor", state: { quizDetails: this.props.quizDetails, classDetails: this.props.classDetails, userDetails: this.props.userDetails } }} >
                                                <Button variant="contained" disabled={this.props.buttonDisable ? true : null } color={this.props.buttonDisable ? null : "primary"} style={{backgroundColor : "#13a89e"}} 
                                                    // onClick={() => {this.props.deleteInProgressAnswerSheet({answerSheetId : this.state.inProgressAnswerSheet[0]._id, userId : this.props.userDetails._id});this.setState({buttonLoader : true, networkErrorInDeleteAnswerSheet : false})}}
                                                >
                                             Resume Quiz 
                                            </Button>
                                            </Link> : ""}
                                        <Typography style={this.state.networkErrorInDeleteAnswerSheet ? { display: "block", color: 'red', fontSize: '12px', marginLeft : "2%" } : { display: "none" }}>* Failed in restart quiz, due to network lost</Typography></div>
                                    }
                                </div>
                            }
                            </div> : 
                            <div>{this.state.buttonLoader ? 
                                <CircularProgress size={40} thickness={3} style={{color : "#13a89e"}} /> : 
                                <div>
                                    { this.props.quizDetails.quiz && this.props.quizDetails.quiz._id ? 
                                    <div>
                                        {this.state.inProgressAnswerSheet.length ?
                                            <div style={{display : "flex"}}>
                                                <Link style={{ textDecoration: "none", color: "white" }} to={{ pathname: "/quiz/proctor", state: { quizDetails: this.props.quizDetails, classDetails: this.props.classDetails, userDetails: this.props.userDetails } }} >
                                                    <Button variant="contained" disabled={this.props.buttonDisable ? true : null } color={this.props.buttonDisable ? null : "primary"} style={{backgroundColor : "#13a89e"}}
                                                        // onClick={() => {this.props.deleteInProgressAnswerSheet({answerSheetId : this.state.inProgressAnswerSheet[0]._id, userId : this.props.userDetails._id}); this.setState({buttonLoader : true, networkErrorInDeleteAnswerSheet : false})}}
                                                        >
                                                        Resume Quiz
                                                    </Button>
                                                </Link>
                                                <Typography style={this.state.networkErrorInDeleteAnswerSheet ? { display: "block", color: 'red', fontSize: '12px', marginLeft : "2%" } : { display: "none" }}>* Failed in restart quiz, due to network lost</Typography></div> 
                                                :
                                                <div>
                                                    <Link style={{ textDecoration: "none", color: "white" }} to={{ pathname: "/quiz/proctor", state: { quizDetails: this.props.quizDetails, classDetails: this.props.classDetails, userDetails: this.props.userDetails } }} ><Button variant="contained" color="primary" style={{backgroundColor : "#13a89e"}}>Continue</Button></Link>
                                                </div>
                                        }
                                    </div> : 
                                    <div>
                                        <Typography style={{ fontWeight: "bold", fontSize: "100%", paddingBottom: "20px" }}>
                                            Quiz not available to attempt
                                        </Typography>
                                    </div>
                                    }
                                </div>
                                }
                            </div>}
                        </ExpansionPanelDetails>
                    </div>
                }
            </ExpansionPanel>
        )
    }
}
function mapStateToProps(state) {
    return {
        deleteAnswerSheet : state.quizReducer.deleteAnswerSheet,
        errorInDeleteAnswerSheet : state.quizReducer.errorInDeleteAnswerSheet,
        // quizDetails: state.courseReducer.quizInfo,
        buttonDisable : state.errorReducer.buttonDisable,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clearmodule: () => { dispatch(CourseActions.Modules())},
        deleteInProgressAnswerSheet : (data) => dispatch(QuizMiddleware.deleteAnswerSheetMiddleware(data)),
        // getquiz: (data) => dispatch(CourseMiddleware.quizInfoMiddleware(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuizInfo)


// WEBPACK FOOTER //
// ./src/container/QuizInfo/quizinfo.js